import { createElement, append, removeClass, addClass, isFunction } from '../../utils';

import popoverPosition from './popoverPosition';

const CN = 'rmp-ext-popover';
const VISIBLE_CN = `${CN}--visible`;

const DELAY = 500;

export default function popover(extension, { $button, text }) {
   const parent = $button.parentNode;
   const span = createElement('span', { class: CN, tabindex: 0 });
   append(parent, span, $button);
   $button.setAttribute('aria-label', isFunction(text) ? text() : text);

   let timerId = 0;

   extension.addEvent($button, 'mouseenter', () => timerId = setTimeout(show, DELAY) );
   extension.addEvent($button, 'mouseleave', hide);
   extension.addEvent($button, 'click', hide);

   function show() {
      span.textContent =  isFunction(text) ? text() : text;
      span.style.left = '0';
      popoverPosition(extension.player, $button, span);
      addClass(span, VISIBLE_CN);
   }

   function hide() {
      clearTimeout(timerId);
      removeClass(span, VISIBLE_CN);
   }
}
